import React, { useState } from 'react';
import { Spinner } from '../../../components/UI';
import {
    Button,
    Paper,
    Box,
    Typography,
    makeStyles,
    IconButton,
    Tooltip,
    TablePagination,
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    Divider,
    ListItemIcon,
} from '@material-ui/core';
import {
    CM_FILTER_CARDS,
    TL_FILTER_CARDS,
    TL_TABLE_COLUMNS,
} from '../../cluster-management/helper.cm';
import Searchbar from '../../../components/Searchbar';
import FilterModal, {
    FilteredState,
} from '../../../components/Modals/FilterModal';
import { CM_TABLE_COLUMNS } from '../../cluster-management/helper.cm';
import {
    CMTableCell,
    CMTableHeadCell,
} from '../../cluster-management/utility.component.cm';
import useSlotList from './useSlotList';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PersonIcon from '@material-ui/icons/Person';
import clsx from 'clsx';
import { BackIcon, ShiftIcon, TrackingEnabledIcon } from '../../../assets/svg';
import ViewAttendanceModal from '../../../components/Modals/ViewAttendenceModal';
import moment from 'moment';
import { SLOT_FILTER_CARDS, SLOT_TABLE_COLUMNS } from './slot.helper';
import { SLOTTableCell, SLOTTableHeadCell } from './utility.component.slot';
import SlotDetailModal from '../../../components/Modals/SlotDetailModal';
import EditCapacityModal from '../../../components/Modals/EditCapacityModal';
import DateRangePicker, {
    DateRange,
} from '../../../components/DateRangePicker/DateRangePicker';
import { HubSwitchKey } from '../Settings';
import { HUB_TYPE_ENUM } from '../../../utils/constants';
import UploadPayEarnModal from '../../../components/Modals/UploadPayEarnModal';
interface SlotListingPageProps {
    [key: string]: any;
}
const SlotListingPage: React.FC = ({ ...props }: SlotListingPageProps) => {
    //store values
    const { setHubNShiftScreenSwitch, hubInfo, permissions } = props;
    const [shiftModalOpen, setShiftModalOpen] = useState(false);
    const [assignSlotModalOpen, setAssignSlotModalOpen] = useState(false);
    const {
        isLoading,
        styles,
        activeFilterCard,
        prepareFilterCard,
        prepareFilterOptions,
        containerRef,
        searchTextValue,
        onFilterApplied,
        filterValues,
        onBackendSearch,
        onSearchTextChange,
        getColumnComponentValue,
        handleActiveFilterCard,
        handleRowClick,
        slotList,
        openDetailModal,
        selectedRow,
        closeDetailModalHandler,
        openDetailModalHandler,
        openEditCapacityModal,
        selectedCapacityRow,
        closeEditCapacityModalHandler,
        fetchSlotsData,
        setFilterValues,
        currentOrgId,
        isBBNowVendor,
        user,
    } = useSlotList(props);
    const enableBulkSlotAssign = !!user?.config?.enableBulkSlotAssign;
    const slotTableColumns = user?.config?.removeEPHForSlots
        ? SLOT_TABLE_COLUMNS.filter(
              (col: any) => col?.mappingKey !== 'earningsPerHr',
          )
        : SLOT_TABLE_COLUMNS;
    const handleRangeChange = (range: DateRange) => {
        console.log('Selected Range:', range);
        setTimeout(() => {
            onFilterApplied?.({
                startDate: moment(range?.startDate).format('YYYY-MM-DD'),
                endDate: moment(range?.endDate).format('YYYY-MM-DD'),
            });
        }, 300);
    };
    const HUB_TYPE_ENUM_NESTED: any = HUB_TYPE_ENUM;
    return (
        <Spinner loading={isLoading}>
            <Paper
                style={{ padding: '14px 24px 16px 14px', marginBottom: 20 }}
                elevation={0}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                        }}
                    >
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Tooltip title="Back" placement="top">
                                <ListItemIcon
                                    onClick={(e) => {
                                        setHubNShiftScreenSwitch(
                                            HubSwitchKey.HUB_VIEW,
                                        );
                                    }}
                                    style={{
                                        minWidth: '0',
                                        color: '#000000',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    <BackIcon style={{}} />
                                </ListItemIcon>
                            </Tooltip>
                            <Typography
                                style={{
                                    fontFamily: 'Nunito',
                                    fontSize: '22px',
                                    fontWeight: 'bold',
                                    color: '#14112d',
                                    margin: 0,
                                }}
                                variant="h6"
                                component="span"
                                gutterBottom
                            >
                                {hubInfo?.name}
                            </Typography>
                        </Box>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'space-between',
                                marginLeft: '2.5rem',
                                marginTop: 0,
                            }}
                        >
                            <Typography
                                style={{
                                    fontFamily: 'Nunito',
                                    fontSize: '18px',
                                    color: '#14112d',
                                    fontWeight: 'bold',
                                }}
                                variant="body1"
                                gutterBottom
                            >
                                {(() => {
                                    let color = '#f44336';
                                    color =
                                        HUB_TYPE_ENUM_NESTED?.[
                                            hubInfo?.primaryOperation?.toUpperCase() as keyof typeof HUB_TYPE_ENUM
                                        ]?.color ?? '#f44336';

                                    return (
                                        <span
                                            style={{ color, fontSize: '16px' }}
                                        >{`${
                                            HUB_TYPE_ENUM_NESTED?.[
                                                hubInfo?.primaryOperation?.toUpperCase() as keyof typeof HUB_TYPE_ENUM
                                            ]?.label ?? '-'
                                        }`}</span>
                                    );
                                })()}
                                <span style={{ color: '#D0CFD5' }}> | </span>
                                <span style={{ fontWeight: 600 }}>
                                    {hubInfo?.cityName}
                                </span>
                                <span style={{ fontWeight: 600 }}>
                                    <span style={{ color: '#D0CFD5' }}>
                                        {' '}
                                        |{' '}
                                    </span>
                                    {` Slots: ${slotList?.slots?.length ?? 0}`}
                                </span>
                                <span style={{ fontWeight: 600 }}>
                                    <span style={{ color: '#D0CFD5' }}>
                                        {' '}
                                        |{' '}
                                    </span>
                                    {` Staffs: ${hubInfo?.staffCount ?? 0}`}
                                </span>
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Button
                            variant="contained"
                            style={{ fontSize: 14 }}
                            color="primary"
                            onClick={(e) => setShiftModalOpen(true)}
                            disabled={
                                !!isBBNowVendor ? false : !permissions.update
                            }
                            startIcon={<ShiftIcon />}
                            disableElevation
                        >
                            {'Add Slot'}
                        </Button>
                        {!!shiftModalOpen && (
                            <UploadPayEarnModal
                                open={shiftModalOpen}
                                data={{
                                    hubId: hubInfo?.id,
                                    orgId: currentOrgId,
                                }}
                                isEdit={false}
                                enumType="slots"
                                onClose={() => {
                                    setShiftModalOpen(false);
                                    fetchSlotsData();
                                }}
                            />
                        )}
                        {enableBulkSlotAssign && (
                            <Button
                                variant="contained"
                                style={{ fontSize: 14, marginLeft: 8 }}
                                color="primary"
                                onClick={() => setAssignSlotModalOpen(true)}
                                disabled={
                                    !!isBBNowVendor
                                        ? false
                                        : !permissions.update
                                }
                                startIcon={<PersonIcon fontSize="small" />}
                                disableElevation
                            >
                                {'Assign Slot'}
                            </Button>
                        )}
                        {!!assignSlotModalOpen && (
                            <UploadPayEarnModal
                                open={assignSlotModalOpen}
                                data={{}}
                                isEdit={false}
                                enumType="slot_assign"
                                uiData={{
                                    title: 'Assign Slot',
                                    subTitle:
                                        'Bulk assign or cancel slot assignments',
                                    buttonText: 'Assign Slot',
                                }}
                                onClose={() => {
                                    setAssignSlotModalOpen(false);
                                    fetchSlotsData();
                                }}
                            />
                        )}
                    </Box>
                </div>
            </Paper>
            <Paper style={{ padding: '1rem', paddingBottom: 0 }} elevation={0}>
                <Box
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    mb={1}
                >
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        flex={1}
                        maxWidth={'40%'}
                    >
                        <Searchbar
                            placeHolderText="Search by Rider’s details"
                            style={{
                                width: 'calc(100vw - 77%)',
                            }}
                            dataSource={null}
                            backendSearchbar={true}
                            onBackendSearch={onBackendSearch}
                            value={searchTextValue}
                            keys={['name', 'hubName']}
                            onFilter={async (filteredData: any) => {}}
                            onChange={onSearchTextChange}
                        />

                        {/*<FilterModal
                            disabled={false}
                            filterOptions={prepareFilterOptions()}
                            filteredValues={filterValues}
                            onFilterApplied={onFilterApplied}
                            onClose={null}
                            onRemoveAll={onRemoveAll}
                        />
                        <FilteredState
                            filterOptions={prepareFilterOptions()}
                            filteredValues={filterValues}
                            onDelete={(filterKey: any) => {}}
                            count={null}
                            selectInfo={null}
                            selected={null}
                            maxShow={4}
                        />*/}
                    </Box>
                    <Box alignSelf={'flex-end'}>
                        <DateRangePicker onChange={handleRangeChange} />
                    </Box>
                </Box>
                <Grid container spacing={2}>
                    {SLOT_FILTER_CARDS?.map((card: any, index: number) => {
                        return (
                            <Grid
                                key={index}
                                xs={card?.xs ? card?.xs : true}
                                item
                                style={{
                                    maxWidth: 'fit-content',
                                    minWidth: '252px',
                                }}
                            >
                                <Paper
                                    className={styles.filterBox}
                                    style={{
                                        cursor: 'pointer',
                                        ...(card?.filterValue?.type ===
                                        activeFilterCard?.type
                                            ? { backgroundColor: '#D1D8FF' }
                                            : {}),
                                    }}
                                    onClick={() => {
                                        handleActiveFilterCard(
                                            card?.filterValue,
                                        );
                                    }}
                                >
                                    {prepareFilterCard(card)}
                                </Paper>
                            </Grid>
                        );
                    })}
                </Grid>
                <Paper
                    ref={containerRef}
                    className={styles.container}
                    elevation={0}
                    style={{ paddingTop: '1rem' }}
                >
                    {slotList?.slots?.length ? (
                        <>
                            <TableContainer
                                component={Box}
                                className={styles.tableTLContainer}
                            >
                                <Table stickyHeader aria-label="Slots table">
                                    <TableHead>
                                        <TableRow>
                                            {slotTableColumns?.map(
                                                (column: any, index: any) => {
                                                    return (
                                                        <SLOTTableHeadCell
                                                            key={`column${index}`}
                                                        >
                                                            {column?.name}
                                                        </SLOTTableHeadCell>
                                                    );
                                                },
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {slotList?.slots?.map(
                                            (row: any, rowIndex?: number) => (
                                                <>
                                                    <TableRow
                                                        key={row.name}
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={(e: any) => {
                                                            handleRowClick(
                                                                e,
                                                                row,
                                                            );
                                                        }}
                                                    >
                                                        {slotTableColumns?.map(
                                                            (
                                                                column: any,
                                                                index: any,
                                                            ) => {
                                                                return (
                                                                    <SLOTTableCell
                                                                        key={`row${index}`}
                                                                    >
                                                                        {getColumnComponentValue(
                                                                            row,
                                                                            column,
                                                                            null,
                                                                        )}
                                                                    </SLOTTableCell>
                                                                );
                                                            },
                                                        )}
                                                    </TableRow>
                                                    <Divider
                                                        style={{
                                                            margin: '4px 0',
                                                            backgroundColor:
                                                                '#fff',
                                                        }}
                                                    />
                                                </>
                                            ),
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    ) : (
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            alignItems={'center'}
                            justifyContent={'center'}
                        >
                            <Typography
                                component={'p'}
                                style={{
                                    color: '#ED0000',
                                    fontWeight: 700,
                                }}
                            >
                                No data found. Please retry filters and try
                                again.
                            </Typography>
                        </Box>
                    )}
                </Paper>
            </Paper>
            {!!openDetailModal && (
                <SlotDetailModal
                    permissions={permissions}
                    open={openDetailModal}
                    hubInfo={props?.hubInfo}
                    data={{ ...(selectedRow || {}) }}
                    isEdit={!!selectedRow}
                    openEditModal={() => {}}
                    openDeleteModal={() => {}}
                    onClose={() => {
                        closeDetailModalHandler();
                    }}
                />
            )}
            {!!openEditCapacityModal && (
                <EditCapacityModal
                    open={openEditCapacityModal}
                    data={{ ...(selectedCapacityRow || {}) }}
                    onClose={() => {
                        closeEditCapacityModalHandler();
                    }}
                />
            )}
        </Spinner>
    );
};
export default SlotListingPage;
